
import { useCallback, useState } from 'react';
import './App.css';
import './styles/animations.css';
import useSmoothScroll from './hooks/useSmoothScroll';
import Loader from './components/organisms/loader';
import Intro from './components/intro';
import About from './components/about'
import Carrier from './components/carrier'
import Skills from './components/skills'
import Qualifications from './components/qualifications'
import Works from './components/works';
import SocialMedia from './components/socialMedia';
import Blog from './components/blog';
import Footer from './components/organisms/footer';


function App() {
  const [loading, setLoading] = useState(true);
  const handleLoaderDone = useCallback(() => setLoading(false), []);

  useSmoothScroll();

  return (
    <div className={`App ${loading ? '' : 'is-loaded'}`}>
      {loading && <Loader onDone={handleLoaderDone} />}
      <Intro />
      <About />
      <Carrier />
      <Skills />
      <Qualifications />
      <Works />
      <SocialMedia />
      <Blog />
      <Footer />
    </div>

  );
}

export default App;
